import { get, post, put, remove } from '../Services/http';

export const WISHLIST_ADD_TO_CART = 'WISHLIST_ADD_TO_CART';
export const WISHLIST_UPDATE = 'WISHLIST_UPDATE';
export const WISHLIST_CHANGE_QUANTITY = 'WISHLIST_CHANGE_QUANTITY';
export const WISHLIST_LOAD_ERROR = 'WISHLIST_LOAD_ERROR';



export const add = ({ articleNumber, quantity = 1, nodeIdToShowNotification = null, notificationMessage = null, hash = '' }) => {
    return (dispatch) => {
        if (!quantity || isNaN(quantity)) {
            return;
        }

        if(window.__litium.preloadState.wishlist.items.filter(x => x.articleNumber == articleNumber).length > 0 && parseInt(quantity) > 0){
            return null;
        }
 
        return post('/api/wishlist/add', { articleNumber, quantity: parseInt(quantity) })
            .then(response => response.json())
            .then((items) => {
                nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
                if(quantity < 0){
                    window.__litium.preloadState.wishlist.items = window.__litium.preloadState.wishlist.items.filter(x => x.articleNumber != articleNumber);
                }
                dispatch({
                    type: WISHLIST_UPDATE,
                    quantity : items.length
                });
            });
    }
}

export const changeQuantity = (articleNumber, quantity) => {
    return {
        type: WISHLIST_CHANGE_QUANTITY,
        articleNumber,
        quantity
    }
}
 
export const updateWishList = () => (dispatch, getState) => {
    return post('/api/wishlist/update', getState().wishlist)
        .then(response => response.json())
        .then(result => {
            dispatch({
                type: WISHLIST_UPDATE,
                payload: {
                    success: true,
                    message: 'Wishlist was updated successfully'
                }
            });
        })
        .catch(ex => {
            dispatch({
                type: WISHLIST_UPDATE,
                payload: {
                    success: false,
                    message: 'There was an error'
                }
            });
        });
}
 
export const addToCart = () => (dispatch) => {
    return post('/api/wishlist/addtocart')
        .then(response => response.json())
        .then(result => {
            dispatch({
                type: WISHLIST_ADD_TO_CART,
                payload: {
                    success: true,
                    message: 'Wishlist items were added to cart successfully'
                }
            })
        })
        .catch(ex => {
            dispatch({
                type: WISHLIST_ADD_TO_CART,
                payload: {
                    success: false,
                    message: 'There was an error'
                }
            });
        });
}